/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getTekeOrderTable = params => {
  return axios.post(`${base}/teke/query_order`, params)
}

export const batchCompleteTekeOrder = params => {
  return axios.post(`${base}/teke/batch_complete_orders`, params)
}

export const batchCancelTekeOrder = params => {
  return axios.post(`${base}/teke/batch_cancel_orders`, params)
}

export const reviewTekeOrderPass = (params) => {
  return axios.post(`${base}/teke/pass_audit_order_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/teke-order/tekeOrder.api.js